export default __webpack_public_path__ + "static/media/NORBERTO de ELIZALDE.a3f8ddc8.jpg";